import { routeStoreLenses } from 'root/src/client/logic/route/lenses'
import { SET_REDIRECT_ROUTE } from 'root/src/client/logic/route/actionIds'

const { setRedirectRoute } = routeStoreLenses

export default {
	[SET_REDIRECT_ROUTE]: (state, payload) => setRedirectRoute(payload, state),
}
